export default __webpack_public_path__ + "logo42b7d31.png";